// extracted by mini-css-extract-plugin
export default {"idChip":"idChip__KIB8j","unspaced":"unspaced__ETXZU"};